<breadcrumbs
  [breadcrumbs]="[{ label: 'ADMIN', url: '/admin' }, { label: 'SETTINGS_UI' }]"
></breadcrumbs>

<page-header title="SETTINGS_UI"></page-header>

<card>
  <form autocomplete="off" class="form">
    <div class="field is-narrow">
      <label class="label" translationEditableDirective="SETTINGS_UI_TITLE">{{
        'SETTINGS_UI_TITLE' | translate
      }}</label>
      <div class="control">
        <input
          class="input is-small"
          name="SETTINGS_UI_TITLE"
          type="text"
          (input)="handleFieldChange($event)"
          [value]="getField(['SETTINGS_UI_TITLE'])"
          [ngClass]="{ 'is-danger': hasError('SETTINGS_UI_TITLE') }"
        />
      </div>
      <p class="help is-danger" *ngIf="hasError('SETTINGS_UI_TITLE')">
        {{ getError('SETTINGS_UI_TITLE') }}
      </p>
    </div>

    <div class="field is-narrow">
      <label
        class="label"
        translationEditableDirective="SETTINGS_UI_DESCRIPTION"
        >{{ 'SETTINGS_UI_DESCRIPTION' | translate }}</label
      >
      <div class="control">
        <input
          class="input is-small"
          name="SETTINGS_UI_DESCRIPTION"
          type="text"
          (input)="handleFieldChange($event)"
          [value]="getField(['SETTINGS_UI_DESCRIPTION'])"
          [ngClass]="{ 'is-danger': hasError('SETTINGS_UI_DESCRIPTION') }"
        />
      </div>
      <p class="help is-danger" *ngIf="hasError('SETTINGS_UI_DESCRIPTION')">
        {{ getError('SETTINGS_UI_DESCRIPTION') }}
      </p>
    </div>

    <div class="field is-narrow" style="max-width: 420px !important">
      <label class="label" translationEditableDirective="SETTINGS_UI_FOOTER">{{
        'SETTINGS_UI_FOOTER' | translate
      }}</label>
      <div class="control">
        <text-editor
          [value]="getField(['SETTINGS_UI_FOOTER'])"
          (onChange)="handleFieldChange($event, 'SETTINGS_UI_FOOTER')"
          [showHeading]="false"
          [showList]="false"
          [showFontSize]="true"
        ></text-editor>
      </div>
      <p class="help is-danger" *ngIf="hasError('SETTINGS_UI_FOOTER')">
        {{ getError('SETTINGS_UI_FOOTER') }}
      </p>
    </div>

    <div class="field is-narrow">
      <label class="label" translationEditableDirective="SETTINGS_UI_LOGIN_LOGO"
        >{{ 'SETTINGS_UI_LOGIN_LOGO' | translate }} (150x150)</label
      >
      <div
        class="image-wrapper mb-4"
        *ngIf="
          !!getField(['SETTINGS_UI_LOGIN_LOGO']) &&
          !getField(['SETTINGS_UI_LOGIN_LOGO']).get('deleted')
        "
      >
        <img
          width="200"
          [src]="getImageUrl(getField(['SETTINGS_UI_LOGIN_LOGO']))"
        />
        <button
          class="button delete-btn is-danger"
          (click)="onImageDelete('SETTINGS_UI_LOGIN_LOGO')"
        >
          <span class="icon is-small">
            <i class="fas fa-trash"></i>
          </span>
        </button>
      </div>

      <div class="control">
        <input
          #file
          type="file"
          accept=".jpg,.jpeg,.png,.svg"
          (change)="
              onFileChange({
                event: $event,
                field: 'SETTINGS_UI_LOGIN_LOGO',
              })
            "
        />
      </div>
      <p class="help is-danger" *ngIf="hasError('SETTINGS_UI_LOGIN_LOGO')">
        {{ getError('SETTINGS_UI_LOGIN_LOGO') }}
      </p>
    </div>

    <div class="field is-narrow">
      <label
        class="label"
        translationEditableDirective="SETTINGS_UI_REPORT_LOGO"
        >{{ 'SETTINGS_UI_REPORT_LOGO' | translate }}</label
      >
      <div
        class="image-wrapper mb-4"
        *ngIf="
          !!getField(['SETTINGS_UI_REPORT_LOGO']) &&
          !getField(['SETTINGS_UI_REPORT_LOGO']).get('deleted')
        "
      >
        <img
          width="200"
          [src]="getImageUrl(getField(['SETTINGS_UI_REPORT_LOGO']))"
        />
        <button
          class="button delete-btn is-danger"
          (click)="onImageDelete('SETTINGS_UI_REPORT_LOGO')"
        >
          <span class="icon is-small">
            <i class="fas fa-trash"></i>
          </span>
        </button>
      </div>
      <div class="control">
        <input
          #file
          type="file"
          accept=".jpg,.jpeg,.png,.svg"
          (change)="
            onFileChange({
              event: $event,
              field: 'SETTINGS_UI_REPORT_LOGO'
            })
          "
        />
      </div>
      <p class="help is-danger" *ngIf="hasError('SETTINGS_UI_REPORT_LOGO')">
        {{ getError('SETTINGS_UI_REPORT_LOGO') }}
      </p>
    </div>
  </form>
</card>

<div class="field is-grouped mt-4 px-3 mb-3">
  <div class="control">
    <button
      [disabled]="isLoading"
      type="submit"
      class="button is-success"
      translationEditableDirective="SAVE"
      (click)="onSubmit($event)"
    >
      {{ 'SAVE' | translate }}
    </button>
  </div>
  <div class="control">
    <a
      [routerLink]="['/admin']"
      class="button is-link is-light"
      translationEditableDirective="CANCEL"
      >{{ 'CANCEL' | translate }}</a
    >
  </div>
</div>
